import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBuildings: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBuildings"><Path d="M14.5 7.5H20.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 19.5V3.5H14.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M22.5 19.5H1.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 8.5H7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 12.5H10.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBuildings;
